import { DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import * as Service from 'types/service';
import { EventAction } from 'utils/analytics/amplitudeEventConstants';
import { ServicePartyDragMode } from 'state/service/ui';
import { amplitudeSendEvent } from 'utils/analytics/amplitude';
import PartyStates from 'constants/partyStateConstants';

/**
 * Locations in the UI where a drag action can be initiated
 */
export type PartyDragSource =
  | 'TABLE'
  | 'PARTY_PANEL'
  | 'TABLE_PANEL'
  | 'PARTY'
  | 'PARTY_GROUP'
  | 'PARTY_MENU'
  | 'TABLE_MENU'
  | 'TIMELINE_BUBBLE';
export interface PartyDragData {
  mode: 'SERVICE';
  id: number;
  fromTableId?: number;
  party: Service.Party;
  dragSource: PartyDragSource;
  extraOffset?: { x: number; y: number };
  noExtraOffset?: boolean;
  onSuccessfulDrop?(): void;
}

/**
 * Dispatch an analytics event to indicate a user started to drag a party
 */
export const trackDragStart = (source: PartyDragSource, location: 'timeline' | 'service') => {
  amplitudeSendEvent(EventAction.PARTY_TABLE_ASSIGNMENT_STARTED, {
    dragSource: source,
    dragLocation: location,
  });
};

export const partySource = {
  beginDrag(props: {
    isCondensed?: boolean;
    /**
     * Identifies the interface element that initiated the drag action.
     * Used for tracking purposes.
     */
    dragSource: PartyDragSource;
    fromTableId?: number;
    fromPopover?: boolean;
    party?: Service.Party;
    onSuccessfulDrop?(): void;
    noExtraOffset?: boolean;
  }): PartyDragData {
    if (!props.party) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return {} as any;
    }

    trackDragStart(props.dragSource, 'service');

    return {
      id: props.party.id,
      mode: 'SERVICE',
      fromTableId: props.fromTableId,
      party: props.party,
      dragSource: props.dragSource,
      extraOffset:
        (!props.isCondensed && props.dragSource === 'PARTY_MENU' && !props.fromPopover) ||
        props.noExtraOffset
          ? undefined
          : {
              x: -240,
              y: -12,
            },
      onSuccessfulDrop: props.onSuccessfulDrop,
    };
  },
  canDrag(props: {
    party?: Service.Party;
    canDragTables?: boolean;
    isReadOnly: boolean;
    dragMode: ServicePartyDragMode;
  }): boolean {
    if (!props.party) {
      return false;
    }
    const preassignModeCanDrag = !(
      (props.party.state === PartyStates.seated ||
        props.party.state === PartyStates.partiallyseated) &&
      props.dragMode === 'ASSIGN'
    );
    return !props.canDragTables && !props.isReadOnly && preassignModeCanDrag;
  },
};

export function collectSource(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}
